<template>
  <div class="row">
    <div class="col">
      <div class="card mb-3 pt-5 pb-5 pr-5 pl-3">
        <div class="row m-0" style="cursor: pointer" @click="desplegar">
          <div class="col p-0">
            <div class="row m-0">
              <div class="col p-0">
                <div class="h5">
                  <smtt-icon class="align-middle" :icon="icon"></smtt-icon>
                  <span class="align-middle">
                    <b>{{ name }}</b>
                  </span>
                </div>
              </div>
              <div class="ml-auto">
                <status-label v-if="routeState === SurveyStatus.RETURNED" variation="alarm">
                  {{ $t('siteDetail.placesList.rooms.returned') }}
                </status-label>
                <status-label v-if="routeState === SurveyStatus.IN_PROGRESS" variation="warning">
                  {{ $t('routeComponent.inProgress') }}
                </status-label>
                <status-label v-if="routeState === SurveyStatus.PENDING" variation="silent">
                  {{ $t('routeComponent.pending') }}
                </status-label>
                <status-label v-if="routeState === SurveyStatus.IN_REVISION" variation="info">
                  {{ $t('routeComponent.inRevision') }}
                </status-label>
                <status-label v-if="routeState === SurveyStatus.COMPLETED" variation="success">
                  {{ $t('routeComponent.completed') }}
                </status-label>
              </div>
            </div>
            <div class="row m-0">
              <div class="col--auto pl-6 pr-0">
                <div class="h6 mx-auto">
                  <smtt-icon class=" align-middle mr-2" icon="info-circle" color="purple"></smtt-icon>
                </div>
              </div>
              <div class="col p-0">
                <div class="align-middle">
                  <span v-if="mapEnabled && distancesAvailable">{{ distance }}
                    <br/></span>
                  {{ sitesCount + ' ' + (sitesCount > 1 ? $t('routeComponent.countSites.plural') : $t('routeComponent.countSites.singular')) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Expansion Zone -->
        <div class="row m-0" v-show="expandido">
          <div class="col p-0">
            <RouteDirectionMap ref="routeMap" @onNearestDistanceLoad="showNearestDistance"
                               :site-locations="siteLocations" :route-key="route.routeKey" />
            <div class="row m-0">
              <div class="col p-0">
                <div class="col p-0" v-if="sitesInProgress.length > 0">
                  <div class="row m-0" v-for="(site, i) of sitesInProgress" :key="site.assignmentId">
                    <div class="col p-0">
                      <hr class="m-0"/>
                      <SiteButtonDetails :site="site" />
                      <hr v-if="i < sitesInProgress.length - 1" class="m-0"/>
                    </div>
                  </div>
                </div>
                <div class="col p-0" v-if="sitesPending.length > 0">
                  <div class="row m-0" v-for="(site, i) of sitesPending" :key="site.assignmentId">
                    <div class="col p-0">
                      <hr class="m-0"/>
                      <SiteButtonDetails :site="site" />
                      <hr v-if="i < sitesPending.length - 1" class="m-0"/>
                    </div>
                  </div>
                </div>
                <div class="col p-0" v-if="sitesCompleted.length > 0">
                  <div class="row m-0" v-for="(site, i) of sitesCompleted" :key="site.assignmentId">
                    <div class="col p-0">
                      <hr class="m-0"/>
                      <SiteButtonDetails :site="site" />
                      <hr v-if="i < sitesCompleted.length - 1" class="m-0"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getEnv from '@/utils/env';

import RouteDirectionMap from '../map/RouteDirectionMap';
import SiteButtonDetails from './RouteComponent/SiteButtonDetails';
import StatusLabel from '@/components/StatusLabel'
import { SurveyStatus } from "@/utils/surveyStatus";

export default {
  'name': 'RouteComponent',
  'props': ['route'],
  'components': {
    RouteDirectionMap,
    SiteButtonDetails,
    StatusLabel,
  },
  data() {
    return {
      'expandido': Boolean,
      'icon': String,
      'distance': `${this.$t('default.loading.label')}...`,
      'sitesCompleted': [],
      'sitesInProgress': [],
      'sitesPending': [],
      'mapEnabled': getEnv('VUE_APP_MAP_ENABLED') === 'true' && getEnv('VUE_APP_LOCATION_DISABLED') !== 'true',
    }
  },
  'computed': {
    SurveyStatus() {
      return SurveyStatus
    },
    name() {
      return this.route.routeId != null ? this.route.routeName : this.route.regionName
    },
    sitesCount() {
      return this.route.totalSites
    },
    routeState() {
      return this.route.routeState
    },
    siteLocations() {
      const locations = []
      for (const site of this.route.sites) {
        locations.push({
          'siteId': site.siteId,
          'address': site.siteFullAddress,
          'coords': site.latitude != null && site.longitude != null ? {
            'lat': site.latitude,
            'lng': site.longitude
          } : null
        })
      }
      return locations
    },
    'distancesAvailable': function () {
      return this.$store.state.siteLocations.some((location) => {
        return this.route.sites.map(s => s.siteId).includes(location.siteId) && !location.notFound
      })
    }
  },
  'methods': {
    desplegar() {
      this.expandido = !this.expandido
      if (this.expandido) {
        this.icon = 'chevron-down'
        this.$refs.routeMap.showDirections()
      } else {
        this.icon = 'chevron-right'
      }
    },
    checkSites(sites) {
      let site = {}
      for (site of sites) {
        if (site.siteStatus === SurveyStatus.PENDING || site.siteStatus === SurveyStatus.ALL_RECURRENT) {
          this.sitesPending.push(site)
        }
        if (site.siteStatus === SurveyStatus.IN_PROGRESS || site.siteStatus === SurveyStatus.IN_REVISION || site.siteStatus === SurveyStatus.RETURNED) {
          this.sitesInProgress.push(site)
        }
        if (site.siteStatus === SurveyStatus.COMPLETED) {
          this.sitesCompleted.push(site)
        }
      }
    },
    'showNearestDistance': function (distance) {
      if (this.mapEnabled) {
        if (distance != null) {
          this.distance = this.$t('routeComponent.distance.nearest.message', { 'distance': distance * 0.00062137119224 })
        } else {
          this.distance = this.$t('routeComponent.distance.nearest.error.message')
        }
      }
    }
  },
  created() {
    this.checkSites(this.route.sites)
    this.expandido = false
    this.icon = 'chevron-right'
  }
}
</script>
